/**
 * How many invoices one upload may carry, and what to say when it carries more.
 *
 * <p><b>Why this is not a constant.</b> The agent enforces the real cap and can change it from an
 * environment variable. A number hardcoded here goes stale silently: the control accepts fifty
 * files, the agent refuses them, and the user is told two different things by one product. The
 * cap is read from `/agent/status`, and this is only the fallback for an agent too old to
 * publish it.
 */

/**
 * The documented default, matching `DEFAULT_MAX_INVOICES_PER_BATCH` in the agent.
 *
 * <p>Used only when `/agent/status` does not carry `limits` — an agent deployed before that
 * field existed. Wrong in the safe direction: refusing a sixth file the agent would have taken
 * is a worse message, not a broken batch.
 */
export const DEFAULT_UPLOAD_CAP = 5;

export function uploadCapMessage(cap: number, attempted: number): string {
  const over = attempted - cap;

  return (
    `You can upload up to ${cap} invoice${cap === 1 ? '' : 's'} at a time. ` +
    (over > 0
      ? `Remove ${over} and try again, or send them in a few smaller batches.`
      : 'Send them in a few smaller batches.')
  );
}
